import {
    indexHtmlSource,
    installChunkReloadHandler,
    manifestSource,
    startAppUpdatePolling,
} from '@ionq/app-update';

// Same inert "no remote" placeholder as vite.config.ts's remote entry (every
// mode file and the dev stack set VITE_MF_REMOTE_URL). A non-manifest
// override (a direct remoteEntry URL) still has its manifest at the same
// directory.
const REMOTE_ENTRY_URL =
    import.meta.env.VITE_MF_REMOTE_URL ||
    'https://localhost:5175/mf-manifest.json';
const remoteManifestUrl = REMOTE_ENTRY_URL.endsWith('.json')
    ? REMOTE_ENTRY_URL
    : new URL('mf-manifest.json', REMOTE_ENTRY_URL).href;

/**
 * Deploy-staleness handling for the shell (see packages/app-update): reload
 * once on a missing-chunk failure, and apply a detected new version on the
 * next navigation.
 *
 * The shell has two independent staleness axes, hence two sources: its own
 * deploys (its index.html asset set) and the remote's (the mf-manifest asset
 * lists — cloud-ui deploys independently, and old remote chunks 404 no-store
 * afterwards). The MF runtime can't replace the manifest poller: it resolves
 * the manifest exactly once, when router.tsx statically imports
 * remote/routes, so its hooks never observe a later deploy.
 */
export function installAppUpdateHandling(): void {
    installChunkReloadHandler();
    startAppUpdatePolling({
        enabled: import.meta.env.PROD,
        sources: [indexHtmlSource(), manifestSource(remoteManifestUrl)],
    });
}
